import { render, staticRenderFns } from "./AccessControl.vue?vue&type=template&id=6a8ed15e&scoped=true"
import script from "./AccessControl.vue?vue&type=script&lang=js"
export * from "./AccessControl.vue?vue&type=script&lang=js"
import style0 from "./AccessControl.vue?vue&type=style&index=0&id=6a8ed15e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8ed15e",
  null
  
)

export default component.exports